<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div>
          <b-button v-if="current_user.role === 'admin'" variant="outline-primary" class="mr-2"
            @click="copyPreviousRow">
            <font-awesome-icon icon="copy" class="mr-1" /> Add Row (Copy Last)
          </b-button>
          <b-button v-if="['admin'].includes(current_user.role) && false" variant="vb-primary"
            @click="showAddModal = true">
            <font-awesome-icon icon="plus" class="mr-1" /> Add Entry
          </b-button>

          <b-button variant="vb-primary" @click="$emit('reloadData')">
            <font-awesome-icon icon="plus" class="mr-1" /> Refresh Data
          </b-button>
        </div>
      </div>
    </div>

    <div ref="tableElement"></div>
    <b-modal v-model="showAddModal" title="Add History Entry" @ok="handleModalSubmit" @hidden="resetForm">
      <form ref="historyForm">
        <b-form-group label="Entry Date"><b-form-input v-model="form.date" type="date" /></b-form-group>
        <b-form-group label="Total Units"><b-form-input v-model.number="form.total" type="number" /></b-form-group>
        <b-form-group label="Rlsd Units"><b-form-input v-model.number="form.rlsd_units" type="number" /></b-form-group>
        <b-form-group label="Sold Units"><b-form-input v-model.number="form.sold_total" type="number" /></b-form-group>
        <b-form-group label="Available Units"><b-form-input v-model.number="form.available"
            type="number" /></b-form-group>
      </form>
    </b-modal>
    <b-modal v-model="noteModalVisible" title="Note Details" ok-only scrollable>

      <div style="white-space: pre-wrap;" v-html="activeNoteContent"></div>
    </b-modal>
  </div>
</template>

<script>
import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { wrapColumns } from "../../utilities/tabulatorSorter";
import 'tabulator-tables/dist/css/tabulator_bootstrap4.min.css';
import { useUserStore } from "../../store/UserStore";
import { BACKEND_URL, FILES } from '../../variables';
import Vue from 'vue';

import axios from "axios";

import HistoryFileUploadCell from '../tabulator_components/HistoryFileUploadCell.vue';

const FileUploadCellComponent = Vue.extend(HistoryFileUploadCell);
export default {
  props: {
    row_data: { type: Array, default: () => [] },
    perPage: { type: Number, default: 20 },
    currentPage: { type: Number, default: 1 },
    project_status: { type: String, default: '' }
  },
  data() {
    return {
      local_rows: [],
      current_user: useUserStore().current_user,
      showAddModal: false,
      header_fields: [],
      form: {
        date: new Date().toISOString().substr(0, 10),
        total: '', rlsd_units: '', sold_total: '', available: '',
      },
      noteModalVisible: false,
      activeNoteContent: '',
      columnModes: {
        avg_size: ['Overwrite', 'SumProduct', 'Unit Mix'],
        avg_price: ['Overwrite', 'SumProduct', 'Unit Mix'],
        avg_psf: ['Overwrite', 'SumProduct', 'Unit Mix'],
        total_net_psf: ['Overwrite', 'Unit Mix']
      },
      modeOptions: [
        { text: 'Overwrite', value: 'Overwrite' },
        { text: 'SumProduct', value: 'SumProduct' },
        { text: 'Unit Mix', value: 'Unit Mix' }
      ]
    };
  },
  watch: {
    model_rowdata: {
      handler(newData) {
        if (this.tabulatorInstance) {
          const currentData = this.tabulatorInstance.getData();
          const isUserEditing = currentData.some(row => row.isEdited || row.isNew);
          if (!isUserEditing) {
            this.tabulatorInstance.setData(newData);
          }
        }
      },
      deep: true
    },
    row_data: {
      handler(newData) {
        const isEditing = this.local_rows.some(r => r.isEdited || r.isNew);
        if (!isEditing) {
          this.local_rows = JSON.parse(JSON.stringify(newData));
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.setHeaderFields();
    this.$nextTick(() => {
      this.initTabulator();
    });
  },
  methods: {
    async approveHistory(rowData) {
      try {
        const formData = new FormData();
        formData.append('date_attr_nid', rowData.nid);

        axios.post(`${BACKEND_URL}api/date_based_attribute_approve`, formData)
          .then(() => {
            this.$bvToast.toast(`Approved NID: ${rowData.nid}`, { variant: 'success' });
            this.$emit('reloadData')
          });
      } catch (error) {
        console.log(error)
      }
    },
    async executeFileDeletion(rowData, index, fileObject, tabulatorRow) {
      try {
        if (fileObject && fileObject.url) {
          const formData = new FormData();
          formData.append('fid', fileObject.fid);

          await axios.post(`${BACKEND_URL}api/delete_file_by_fid`, formData);
          this.makeToast('Deleted', 'File removed successfully', 'success');
        }

        const updatedFiles = [...rowData.field_update_files];
        updatedFiles.splice(index, 1);

        tabulatorRow.update({
          field_update_files: updatedFiles
        });

        this.syncDataChange(tabulatorRow.getData());

      } catch (error) {
        console.error("Delete File Error:", error);
        this.makeToast('Error', 'Failed to delete file', 'danger');
      }
    },
    async deleteHistory(rowData) {
      const vm = this;
      const url = `${BACKEND_URL}api/utc_date_based_attributes/delete`
      var row = vm.tabulatorInstance.getRow(rowData.nid)
      try {
        const formData = new FormData();
        formData.append('nid', rowData.nid || '');
        formData.append('uid', this.$router.currentRoute.query.uid || 0);

        const response = await axios.post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (response.status == 200) {
          this.makeToast('Success', 'History entry deleted.', 'success');
          this.tabulatorInstance.deleteRow(rowData.nid);
          this.syncDataChange({ ...rowData, isDeleted: true });
        }
      } catch (error) {
        console.error("Delete Error:", error);
        this.makeToast('Error', 'Failed to delete: ' + (error.response?.data?.message || 'Server Error'), 'danger');
      }
    },
    async handleRowSave(rowData) {
      const isUpdate = !rowData.isNew && rowData.isEdited;

      let dateToUnix = null;
      if (rowData.date) {
        const parsedDate = new Date(rowData.date);
        if (!isNaN(parsedDate.getTime())) {
          dateToUnix = Math.floor(parsedDate.getTime() / 1000);
        } else {
          dateToUnix = Math.floor(this.parseCustomDate(rowData.date) / 1000);
        }
      }

      try {
        const formData = new FormData();

        if (isUpdate)
          formData.append('date_attr_nid', rowData.nid || '');

        formData.append('field_need_approval', this.isSuperAdmin ? 0 : 1);

        formData.append('date', dateToUnix || null);
        formData.append('total_units', rowData.total || 0);
        formData.append('rlsd_units', rowData.rlsd_units || 0);
        formData.append('sold', rowData.sold_total || 0);
        formData.append('available_units', rowData.available || 0);
        formData.append('total_avg_psf', rowData.avg_psf || 0);
        formData.append('total_avg_price', rowData.avg_price || 0);
        formData.append('total_avg_size', rowData.avg_size || 0);
        formData.append('field_total_net_psf', rowData.total_net_psf || 0);
        formData.append('deposit', rowData.field_deposit_ || 0);
        formData.append('note', rowData.field_update_notes || '');
        formData.append('uid', this.$router.currentRoute.query.uid || 0);
        if (rowData._pendingFiles && rowData._pendingFiles.length > 0) {
          rowData._pendingFiles.forEach((file) => {
            formData.append('updatefiles[]', file);
          });
        }
        const url = isUpdate
          ? `${BACKEND_URL}api/utc_date_based_attributes/edit`
          : `${BACKEND_URL}api/utc_date_based_attributes/add`;

        const response = await axios.post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (response.status == 200) {
          this.makeToast('Success', 'History entry saved.', 'success');
          const row = this.tabulatorInstance.getRows().find(r => {
            const d = r.getData();
            return (isUpdate && d.id === rowData.id) || (d.cid === rowData.cid);
          });

          if (row) {
            row.update({
              ...response.data.data,
              isEdited: false,
              isNew: false,
              _pendingFiles: []
            });
            row.reformat();
          }
          this.syncDataChange({ ...rowData, isEdited: false, isNew: false });
          this.$emit('reloadData')
        }
      } catch (error) {
        console.error("Save Error:", error);
        this.makeToast('Error', 'Failed to save: ' + (error.response?.data?.message || 'Server Error'), 'danger');
      }
    },

    makeToast(title, message, variant = 'success') {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
        autoHideDelay: 3000,
        appendToast: true,
        toaster: 'b-toaster-top-right'
      });
    },
    syncDataChange(updatedRow) {
      const index = this.local_rows.findIndex(item =>
        (updatedRow.cid && item.cid === updatedRow.cid) ||
        (updatedRow.id && item.id === updatedRow.id)
      );

      if (index !== -1) {
        const newObject = { ...updatedRow, isEdited: true };
        this.$set(this.local_rows, index, newObject);
        this.$emit('data-changed', this.local_rows);
      }
    },

    formatUnixToCustom(unix) {
      if (!unix) return "-";
      const date = new Date(Number(unix) < 10000000000 ? unix * 1000 : unix);
      if (isNaN(date.getTime())) return unix;

      const day = String(date.getDate()).padStart(2, '0');
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = months[date.getMonth()];
      const year = String(date.getFullYear()).slice(-2);
      return `${day}-${month}-${year}`;
    },

    formatToISODate(val) {
      if (!val) return "";
      const date = new Date(isNaN(val) ? val : (Number(val) < 10000000000 ? val * 1000 : val));
      if (isNaN(date.getTime())) return "";
      return date.toISOString().split('T')[0];
    },

    parseCustomDate(dateStr) {
      if (!dateStr) return 0;
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return new Date(dateStr).getTime();

      const months = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
      const parts = dateStr.split('-');
      if (parts.length !== 3) return 0;
      let year = parseInt(parts[2]);
      year = year < 50 ? 2000 + year : 1900 + year;
      return new Date(year, months[parts[1].toLowerCase()], parseInt(parts[0])).getTime();
    },
    filesFormatter(cell) {
      const val = cell.getValue();
      if (!Array.isArray(val)) return '';
      return val.map(item => `<a href="${item.url}" target="_blank">${item.index}</a>`).join(', ');
    },
    renderPriceCell(rowData, field) {
      const modes = this.columnModes[field] || [];
      const systemFieldMap = {
        'avg_size': 'field_system_total_avg_size',
        'avg_price': 'field_system_total_avg_price',
        'avg_psf': 'field_system_psf',
        'total_net_psf': 'total_net_psf'
      };
      const unitMixFieldMap = {
        'avg_size': 'currentAvailability_avg_size',
        'avg_price': 'currentAvailability_avg_price',
        'avg_psf': 'currentAvailability_avg_psf',
        'total_net_psf': 'currentAvailability_net_psf'
      };

      const format = (val) => {
        if (val === null || val === undefined || val === '' || val === 'undefined') return '-';
        if (field === 'avg_size') return Math.round(Number(val)).toLocaleString();
        if (field.includes('psf')) return this.keepDecimalPlace(val);
        return this.roundToWholeNumber(val);
      };

      let parts = [];
      if (modes.includes('Overwrite')) parts.push(`<span style="color: #0056b3; font-weight: bold;">${format(rowData[field])}</span>`);
      if (modes.includes('SumProduct')) parts.push(`<span>${format(rowData[systemFieldMap[field]])}</span>`);
      if (modes.includes('Unit Mix')) parts.push(`<span style="color: #28a745;">${format(rowData[unitMixFieldMap[field]])}</span>`);

      if (modes.length === 0) parts.push(`<span>${format(rowData[field])}</span>`);

      const prevSystemKey = 'prev_system_' + field;
      const trendArrow = modes.includes('SumProduct') ? this.getChangeHTML(rowData[prevSystemKey], rowData[systemFieldMap[field]]) : '';

      return `<div class="d-flex justify-content-between"><div>${parts.join(' | ')}</div>${trendArrow}</div>`;
    },

    setHeaderFields() {
      const role = this.current_user.role;
      if (['developer', 'developerbc'].includes(role)) {
        this.header_fields = [
          { label: 'Date', key: 'date' },
          { label: 'Total Units', key: 'total' },
          { label: 'Rlsd Units', key: 'rlsd_units' },
          { label: 'Total Sold', key: 'sold_total' },
          { label: 'Avail', key: 'available' },
          { label: 'Sold Update', key: 'sold_update' },
        ];
      } else if (role === 'admin') {
        this.header_fields = [
          { label: 'Date', key: 'date' },
          { label: 'Total Units', key: 'total' },
          { label: 'Rlsd Units', key: 'rlsd_units' },
          { label: 'Total Sold', key: 'sold_total' },
          { label: 'Avail', key: 'available' },
          { label: 'Total Avg Price', key: 'avg_price' },
          { label: 'Total $PSF', key: 'avg_psf' },
          { label: 'Net Price', key: 'current_total_net_price' },
          { label: 'Net $PSF', key: 'total_net_psf' },
          { label: 'Files', key: 'files' },
          { label: 'Sold Update', key: 'field_sold_update' },
          { label: 'Notes', key: 'note' },
          { label: 'Status', key: 'approval_status' },
        ];
      }
    },
    initTabulator() {
      if (this.$refs.tableElement) {
        const FILTERED_DATA = this.model_rowdata.filter(item => {
          return this.isAdmin ? true : item.field_need_approval !== '1';
        });
        this.tabulatorInstance = new Tabulator(this.$refs.tableElement, {
          data: FILTERED_DATA,
          columns: wrapColumns(this.tabulatorColumns),
          index: "nid",
          layout: "fitDataStretch",
          movableRows: true,
        });
        this.tabulatorInstance.on("cellEdited", (cell) => {
          const newValue = cell.getValue();
          const oldValue = cell.getOldValue();
          const field = cell.getField();

          if (field === 'date' && (!newValue || newValue === "")) {
            cell.setValue(oldValue);
            return;
          }

          const row = cell.getRow();
          row.update({ isEdited: true });
          this.syncDataChange(row.getData());

          this.$nextTick(() => {
            row.reformat();
          });
        });
        this.tabulatorInstance.on("tableBuilt", () => {
          this.$refs.tableElement.addEventListener('change', (e) => {
            if (e.target.classList.contains('mode-multiselect')) {
              const field = e.target.getAttribute('data-field');
              const selected = Array.from(e.target.selectedOptions).map(opt => opt.value);

              this.columnModes[field] = selected;

              this.tabulatorInstance.setColumns(this.tabulatorColumns);
            }
          });
        });
      }
    },
    parseCustomDate(dateStr) {
      if (!dateStr) return 0;
      if (dateStr.includes('-') && dateStr.split('-')[0].length === 4) return new Date(dateStr).getTime();
      const months = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
      const parts = dateStr.split('-');
      if (parts.length !== 3) return 0;
      let year = parseInt(parts[2]);
      year = year < 50 ? 2000 + year : 1900 + year;
      return new Date(year, months[parts[1].toLowerCase()], parseInt(parts[0])).getTime();
    },
    priceFormatter(cell) {
      const data = cell.getData();
      const field = cell.getField();
      const modes = this.columnModes[field] || [];
      const isNew = data.isNew;
      const showManual = modes.includes('Overwrite');
      const showSystem = modes.includes('SumProduct');
      const showUnitMix = modes.includes('Unit Mix');

      const defaultFieldMap = {
        'avg_size': 'default_field_total_avg_size',
        'avg_price': 'default_field_system_total_avg_price',
        'avg_psf': 'avg_psf',
        'total_net_psf': 'default_field_total_net_psf'
      };

      const systemFieldMap = {
        'avg_size': 'field_system_total_avg_size',
        'avg_price': 'field_system_total_avg_price',
        'avg_psf': 'field_system_psf',
        'total_net_psf': 'field_system_psf'
      };

      const unitMixFieldMap = {
        'avg_size': 'currentAvailability_avg_size',
        'avg_price': 'currentAvailability_avg_price',
        'avg_psf': 'currentAvailability_avg_psf',
        'total_net_psf': 'currentAvailability_net_psf'
      };

      let manualVal = data[field];
      const defaultValue = data[defaultFieldMap[field]];

      if (manualVal === null || manualVal === undefined || manualVal === '') {
        manualVal = defaultValue;
      }

      const systemVal = data[systemFieldMap[field]];
      const unitMixVal = data[unitMixFieldMap[field]];

      const format = (val) => {
        if (val === null || val === undefined || val === '' || val === 'undefined') return '-';
        if (field === 'avg_size') return Math.round(Number(val)).toLocaleString();
        if (field.includes('psf')) return this.keepDecimalPlace(val);
        return this.roundToWholeNumber(val);
      };

      let parts = [];

      if (showManual || modes.length === 0) {
        const isOverwritten = data[field] !== null && data[field] !== '' && data[field] !== undefined;
        const color = isOverwritten ? '#0056b3' : '#666';
        const weight = isOverwritten ? 'bold' : 'normal';

        parts.push(`<span style="color: ${color}; font-weight: ${weight};" title="${isOverwritten ? 'Manual Overwrite' : 'Default Value'}">${format(manualVal)}</span>`);
      }

      const prevSystemKey = 'prev_system_' + field;
      const trendArrow = showSystem ? this.getChangeHTML(data[prevSystemKey], systemVal) : '';

      return `
    <div class="d-flex align-items-center justify-content-between w-100">
      <div style="white-space: nowrap;">
        ${parts.join(' <span style="color: #ccc; margin: 0 4px;">|</span> ')}
      </div>
      ${trendArrow}
    </div>
  `;
    },
    getChangeHTML(oldV, newV) {
      const oldNum = Number(oldV);
      const newNum = Number(newV);
      if (!oldNum || !newNum || Math.abs(newNum - oldNum) < 0.01) return '';

      let diff = 0;
      if (!oldNum && newNum) {
        diff = 100;
      } else if (oldNum > 0 && newNum > 0) {
        diff = Number(((newNum - oldNum) / oldNum) * 100).toFixed(2);
      }

      const color = diff > 0 ? 'green' : 'red';
      const icon = diff > 0 ? 'fa-long-arrow-alt-up' : 'fa-long-arrow-alt-down';
      return `<span style="color:${color}; font-weight:bold; margin-left:5px">(${diff}% <i class="fas ${icon}"></i>)</span>`;
    },
    roundToWholeNumber(v) {
      if (v === null || v === undefined || v === '' || isNaN(v)) return '';
      return '$' + Math.round(Number(v)).toLocaleString();
    },
    keepDecimalPlace(v) {
      if (v === null || v === undefined || v === '' || isNaN(v)) return '';
      return '$' + Number(v).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    async copyPreviousRow() {
      const rows = this.tabulatorInstance.getRows();
      let baseData = {};
      if (rows.length > 0) {
        const lastRow = rows[rows.length - 1];
        baseData = { ...lastRow.getData() };
        baseData.avg_size = baseData.fe_avg_size || null;
        delete baseData.id;
        delete baseData.nid;
        delete baseData.cid;
      }
      ['avg_size', 'avg_price', 'avg_psf'].forEach(field => {
        this.columnModes[field] = ['Overwrite', 'SumProduct', 'Unit Mix'];
      });
      const newData = {
        ...baseData,
        date: this.formatUnixToCustom(Date.now()),
        isNew: true,
        isEdited: false,
        field_update_files: [],
        _pendingFiles: [],
        field_update_notes: '',
        field_need_approval: this.isSuperAdmin ? 0 : 1
      };
      await this.tabulatorInstance.addRow(newData, false);
    },
    handleModalSubmit() { this.$emit('saveHistory', { ...this.form }); },
    resetForm() { this.form = { date: new Date().toISOString().substr(0, 10), total: '', rlsd_units: '', sold_total: '', available: '' }; }
  },
  computed: {
    isSuperAdmin() {
      return [
        "darcysrai@gmail.com",
        "erloucabilan94@gmail.com", 'mark.wang+urban@devradius.com'
      ].includes(this.current_user.mail);
    },
    computedHeaderFields() {
      const role = this.current_user.role;
      let fields = [];

      if (['developer', 'developerbc'].includes(role)) {
        fields = [
          { label: 'Date', key: 'date' },
          { label: 'Total Units', key: 'total' },
          { label: 'Rlsd Units', key: 'rlsd_units' },
          { label: 'Total Sold', key: 'sold_total' },
          { label: 'Avail', key: 'available' },
          { label: 'Sold Update', key: 'sold_update' },
        ];
      } else if (role === 'admin') {
        fields = [
          { label: 'Date', key: 'date' },
          { label: 'Total Units', key: 'total' },
          { label: 'Rlsd Units', key: 'rlsd_units' },
          { label: 'Total Sold', key: 'sold_total' },
          { label: 'Avail', key: 'available' },
          { label: 'Total Avg Size', key: 'avg_size' },
          { label: 'Total Avg Price', key: 'avg_price' },
          { label: 'Total $PSF', key: 'avg_psf' },
          { label: 'Net Price', key: 'current_total_net_price' },
          { label: 'Net $PSF', key: 'total_net_psf' },
          { label: 'Sold Update', key: 'field_sold_update' },
          { label: 'Deposit %', key: 'field_deposit_' },
          { label: 'Notes', key: 'field_update_notes' },
          { label: 'Files', key: 'field_update_files' },
        ];
      }

      return fields.map(f => ({
        key: f.key,
        label: f.label,
        sortable: true,
        thClass: 'text-nowrap'
      }));
    },
    model_rowdata() {
      return this.row_data.map(item => {
        let normalizedDate = item.date;
        if (item.date) {
          normalizedDate = this.formatToISODate(item.date);
        }
        return {
          ...item,
          date: normalizedDate,
          isEdited: item.isEdited || false,
          isNew: item.isNew || false
        };
      });
    },
    tabulatorColumns: {
      get: function () {
        const isAdmin = this.current_user.role === 'admin';
        let headers = [];
        if (isAdmin) {
          headers = [
            { label: 'Date', key: 'date' },
            { label: 'Total Units', key: 'total' },
            { label: 'Rlsd Units', key: 'rlsd_units' },
            { label: 'Total Sold', key: 'sold_total' },
            { label: 'Avail', key: 'available' },
            { label: 'Total Avg Size', key: 'avg_size' },
            { label: 'Total Avg Price', key: 'avg_price' },
            { label: 'Total $PSF', key: 'avg_psf' },
            { label: 'Net Price', key: 'current_total_net_price' },
            { label: 'Net $PSF', key: 'total_net_psf' },
            { label: 'Sold Update', key: 'field_sold_update' },
            { label: 'Deposit %', key: 'field_deposit_' },
            { label: 'Notes', key: 'field_update_notes' },
            { label: 'Files', key: 'field_update_files' },
            { label: 'Status', key: 'field_need_approval' },
          ];
        } else {
          headers = [
            { label: 'Date', key: 'date' },
            { label: 'Total Units', key: 'total' },
            { label: 'Rlsd Units', key: 'rlsd_units' },
            { label: 'Total Sold', key: 'sold_total' },
            { label: 'Avail', key: 'available' },
            { label: 'Sold Update', key: 'sold_update' },
          ];
        }

        const headersWithActions = [
          { label: "Actions", key: "row_save_btn", width: 100 },
          ...headers,
        ];

        const numericFields = ['total', 'rlsd_units', 'sold_total', 'avg_size'];
        const psfFields = ['avg_psf', 'total_net_psf'];

        return headersWithActions.map(col => {
          let displayTitle = col.label;
          const modeControlledFields = ['avg_size', 'avg_price', 'avg_psf', 'total_net_psf'];
          let columnConfig = {
            field: col.key,
            title: displayTitle,
            vertAlign: "middle",
            hozAlign: "left",
            width: col.width || undefined
          };
          if (modeControlledFields.includes(col.key)) {
            columnConfig.height = 90;
            columnConfig.editor = (isAdmin && (this.columnModes[col.key] || []).includes('Overwrite')) ? "number" : false;
            columnConfig.formatter = this.priceFormatter;
          }
          if (col.key == "field_need_approval") {
            columnConfig.formatter = (cell) => {
              const val = cell.getValue();
              var resultVal = val?.und?.[0]?.['value'] || val;
              const color = resultVal === '0' ? 'green' : '#808080';
              const text = resultVal === '0' ? 'Approved' : 'Pending';
              if (!this.isSuperAdmin && isAdmin) {
                return `<span style="color: ${color}; font-weight: bold;">${text}</span>`;
              } else if (this.isSuperAdmin) {
                if (resultVal == '1')
                  return `<button class="btn btn-vb-primary approve-btn">Approve</button>`;
                return `<span style="color: ${color}; font-weight: bold;">${text}</span>`;
              }
            };

            columnConfig.cellClick = (e, cell) => {
              const target = e.target.closest('button');
              if (!target) return;
              const row = cell.getRow();
              const rowData = row.getData();
              if (target.classList.contains('approve-btn')) {
                if (confirm("Are you sure you want to approve this history entry?")) {
                  this.approveHistory(rowData);
                }
              }
            };
          }
          if (col.key === "row_save_btn") {
            columnConfig.frozen = true;
            columnConfig.hozAlign = "center";
            columnConfig.headerSort = false;
            columnConfig.formatter = (cell) => {
              const data = cell.getData();
              if (data.isEdited && !data.isNew) {
                return `
    <div class="d-flex justify-content-center">
      <button class="btn btn-success btn-xs py-0 px-1 action-save" style="font-size:14px">Save</button>
    </div>`;
              }
              else if (data.isNew) {
                return `
                <div class="d-flex justify-content-center">
                  <button class="btn btn-success btn-xs py-0 px-1 mr-1 action-save" style="font-size:14px">Save</button>
                  <button class="btn btn-danger btn-xs py-0 px-1 action-delete" style="font-size:10px">Del</button>
                </div>`;
              }
              else {
                return `<button class="btn btn-danger btn-xs py-0 px-1 delete-history" style="font-size:10px" >Delete</button>`
              }
            };
            columnConfig.cellClick = (e, cell) => {
              const target = e.target.closest('button');
              if (!target) return;
              const row = cell.getRow();
              const rowData = row.getData();
              if (target.classList.contains('action-save')) {
                this.handleRowSave(rowData);
                row.update({ isNew: false, isEdited: false });
                row.reformat();
              } else if (target.classList.contains('action-delete')) {
                if (confirm("Are you sure you want to delete this row?")) row.delete();
              } else if (target.classList.contains('delete-history')) {
                if (confirm("Are you sure you want to delete this history entry?")) {
                  this.deleteHistory(rowData);
                }
              }
            };
          }
          if (col.key === "avg_size") {
            columnConfig.hozAlign = "left";
            columnConfig.formatter = this.priceFormatter;
            columnConfig.editor = isAdmin ? "number" : false;
          }
          if (col.key === "date") {
            columnConfig.width = 110;
            columnConfig.editor = isAdmin ? "date" : false;

            columnConfig.formatter = (cell) => {
              const val = cell.getValue();
              if (!val) return "-";

              const timestamp = isNaN(new Date(val).getTime())
                ? this.parseCustomDate(val)
                : new Date(val).getTime();

              return this.formatUnixToCustom(timestamp / 1000);
            };
          }
          else if (col.key === "current_total_net_price") {
            columnConfig.editor = false;
            columnConfig.formatter = (cell, row) => {
              const val = cell.getRow();
              var result = Number((val._row.data.total_net_psf || 0) * (val._row.data.avg_size || 0))
              return result ? `$${result.toLocaleString()}` : '-';
            };
          }
          else if (col.key === "avg_price") {
            columnConfig.editor = false;
            columnConfig.formatter = (cell, row) => {
              const val = cell.getRow();
              var result = Number((val._row.data.avg_size || 0) * (val._row.data.avg_psf || 0))
              return result ? `$${result.toLocaleString()}` : '-';
            };
          } else if (col.key === "available") {
            columnConfig.editor = false;
            columnConfig.formatter = (cell, row) => {
              const val = cell.getRow();
              const sold = !['-', '', 0, '0', 'null', null].includes(val._row.data.sold_total) ? Number(val._row.data.sold_total) : 0;
              return ((val._row.data.rlsd_units || 0) - sold);
            };
          }
          else if (numericFields.includes(col.key)) {
            columnConfig.hozAlign = "center";
            columnConfig.editor = isAdmin ? "number" : false;
          }
          else if (col.key === "field_deposit_") {
            columnConfig.hozAlign = "center";
            columnConfig.editor = isAdmin ? "textarea" : false;
          }
          else if (col.key === "field_update_notes") {
            columnConfig.width = 250;
            columnConfig.editor = isAdmin ? "textarea" : false;

            columnConfig.formatter = (cell) => {
              const val = cell.getValue();
              if (!val || val == 0 || val == '<p>0</p>') return "";

              if (val.length <= 20) return val;

              const truncated = val.substring(0, 20);
              return `
                <div class="note-cell-container">
                  <span>${truncated}...</span>
                  <a href="javascript:void(0);" class="read-more-link" style="color: #007bff; cursor: pointer;">Read more</a>
                </div>
              `;
            };

            columnConfig.cellClick = (e, cell) => {
              if (e.target.classList.contains('read-more-link')) {
                e.stopPropagation();

                this.activeNoteContent = cell.getValue();
                this.noteModalVisible = true;
              }
            };
          }
          else if (col.key === "field_update_files") {
            columnConfig.width = 140;
            columnConfig.hozAlign = "center";

            columnConfig.formatter = (cell) => {
              const data = cell.getData();
              const shimRow = {
                ...data,
                field_update_files: data.field_update_files || [],
                _pendingFiles: data._pendingFiles || []
              };

              const instance = new FileUploadCellComponent({
                propsData: { row: shimRow }
              });

              instance.$on('delete-file', (fileIndex) => {
                const row = cell.getRow();
                const currentData = row.getData();

                const fileToDelete = currentData.field_update_files[fileIndex];
                this.executeFileDeletion(currentData, fileIndex, fileToDelete, row);
              });

              instance.$on('files-selected', (files) => {
                const row = cell.getRow();
                const currentData = row.getData();

                const newPendingSet = [...(currentData._pendingFiles || []), ...files];

                row.update({
                  _pendingFiles: newPendingSet,
                  isEdited: true
                });

                this.syncDataChange(row.getData());
                row.reformat();
              });

              instance.$mount();
              return instance.$el;
            };
          }
          else if (col.key === "note") {
            columnConfig.formatter = (cell) => cell.getValue() ? '<button class="btn btn-xs btn-primary">View</button>' : '';
            columnConfig.cellClick = (e, cell) => this.$emit('getHistoryNote', { notes: cell.getValue() });
          }
          else if (col.key === "field_sold_update") {
            columnConfig.editor = isAdmin ? "input" : false;
          }

          return columnConfig;
        });
      },
      set: function (newVal) {
        return newVal;
      }
    },
  }
}
</script>

<style scoped>
:deep(.btn-xs) {
  padding: 1px 5px !important;
  display: inline-block !important;
}

:deep(.read-more-link:hover) {
  text-decoration: underline !important;
}

:deep(.note-cell-container) {
  display: flex;
  align-items: center;
  overflow: hidden;
}

:deep(.action-save) {
  min-width: 45px;
  line-height: 1.2;
}

:deep(.tabulator-cell) {
  display: flex;
  align-items: center;
  /* Ensures buttons are centered vertically */
}

/* Ensure the action column doesn't clip buttons */
:deep(.tabulator-col[field="row_save_btn"]) {
  overflow: visible !important;
}
</style>
